import React from "react";
import { Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import Loading from "./components/Loading";

import { useAuth0 } from "./react-auth0-spa";
import history from "./utils/history";

// import Layout from "./views/Layout";
import Main from "./views/Main";

// styles
import "antd/dist/antd.css";
import "./App.css";

// fontawesome
import initFontAwesome from "./utils/initFontAwesome";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

initFontAwesome();

const App = () => {
  const {
    loading,
    user,
    isAuthenticated,
    loginWithRedirect,
    getTokenSilently,
    logout,
  } = useAuth0();

  if (loading) {
    return <Loading />;
  }
  if (!isAuthenticated) {
    loginWithRedirect();
  }

  const logoutWithRedirect = () =>
    logout({
      returnTo: window.location.origin,
    });

  return (
    <QueryClientProvider client={queryClient}>
      <Router history={history}>
        {isAuthenticated && (
          <Main
            user={user}
            loading={loading}
            token={getTokenSilently()}
            logout={logoutWithRedirect}
          />
        )}
      </Router>
    </QueryClientProvider>
  );
};

export default App;
